import { render, staticRenderFns } from "./CustomerParticipants.vue?vue&type=template&id=2284e58f&scoped=true&"
import script from "./CustomerParticipants.vue?vue&type=script&lang=ts&"
export * from "./CustomerParticipants.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerParticipants.vue?vue&type=style&index=0&id=2284e58f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284e58f",
  null
  
)

export default component.exports